import React from 'react';
import { Tabs } from 'react-tabs';

import hoistNonReactStatics from 'hoist-non-react-statics';

import { styled } from '../theme';

const StyledTabs = styled(Tabs)<{}>({
    display: 'flex',
    flexFlow: 'column',
    flexShrink: 0,
    height: '100%',
    position: 'relative',
});

const TabsContainer = React.forwardRef<any, any>((props, ref) => (
    <StyledTabs ref={ref} selectedTabClassName="active" {...props} />
));

export default hoistNonReactStatics(TabsContainer, Tabs);
